import { CartUpdateEvent, CartContentUpdateEvent } from "@gob/events";

class CartStore {
  constructor() {
    this.cart = null;
  }

  async loadCart() {
    const response = await fetch(Theme.routes.cart_url)
    const data = await response.json()
    this.cart = data

    document.dispatchEvent(new CartUpdateEvent(this.cart))
  }

  async removeItem(index) {
    try {
      const response = await fetch(Theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line: index, quantity: 0, sections: 'cart-drawer' }),
      })
      
      if (!response.ok) {
        throw new Error('Failed to remove item')
      }

      const data = await response.json()
      const cartDrawer = data?.sections?.['cart-drawer']

      if (cartDrawer) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(cartDrawer, 'text/html')
        const cartDrawerContent = doc.querySelector('.cart-drawer__content')
        
        document.dispatchEvent(new CartContentUpdateEvent(cartDrawerContent.innerHTML))
      }

      this.loadCart()
    } catch (error) {
      console.error('Error removing item:', error)

    }
  }

  async updateQuantity(index, quantity) {
    try {
      const response = await fetch(Theme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ line: index, quantity, sections: 'cart' }),
      })
      
      if (!response.ok) {
        throw new Error('Failed to update quantity')
      }

      const data = await response.json()
      const cartSection = data?.sections?.['cart']

      if (cartSection) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(cartSection, 'text/html')
        const cartSectionContent = doc.querySelector('.cart-drawer__content').cloneNode(true)
        
        window.dispatchEvent(new CartContentUpdateEvent(cartSectionContent.innerHTML))
      }

      this.loadCart()
    } catch (error) {
      console.error('Error updating quantity:', error)

    }
  }
}

export const cartStore = new CartStore();